




















































import Vue from "vue";
import calendar from "../../components/calendar.vue";
import { DateTime } from "luxon";

type PermissionSelect = {
  permission: string;
  text: string;
};

export default Vue.extend({
  components: {
    calendar,
  },
  data() {
    return {
      expireAt: null, //DateTime.local().toFormat("yyyy-MM-dd"),
      menu: false,
      permissionsSelected: [] as Array<PermissionSelect>,
      validForm: false,
      saving: false,
      minDate: DateTime.local().toFormat("yyyy-MM-dd"),
      permissions: [
        { permission: "search_recordings", text: "Buscar grabaciones" },
        { permission: "listen_to_recordings", text: "Escuchar grabaciones" },
        { permission: "tag_recordings", text: "Etiquetar grabaciones" },
      ] as Array<PermissionSelect>,
    };
  },
  props: {
    customerId: {
      type: Number,
    },
  },
  computed: {
    allowSave(): boolean {
      if (
        !this.saving &&
        this.customerId &&
        this.permissionsSelected &&
        this.permissionsSelected.length > 0
      ) {
        return true;
      }
      return false;
    },
  },
  methods: {
    async save() {
      this.saving = true;
      const permissions = this.permissionsSelected.map((t) => t.permission);
      const fecha = this.expireAt as any;
      let expireAtWithFormat = null;
      if (fecha) {
        expireAtWithFormat =
          DateTime.fromISO(fecha as string).toFormat("yyyy-MM-dd") +
          "T00:00:00-00:00";
      }

      const newApiKey = {
        permissions: permissions,
        customerId: this.customerId,
        expireAt: expireAtWithFormat,
      };
      try {
        await this.$store.dispatch("customers/createAPIKey", newApiKey);
        this.$router.push("/apikeys");
        this.saving = false;
      } catch (err) {
        this.saving = false;
      }
    },
  },
});
